// Universal loading component
import React from "react";
import { ThreeDots } from "react-loader-spinner";

const Loading = ({height= 80}) => {
  return (
    <div className="flex items-center justify-center w-full mx-2">
      <ThreeDots
        visible={true}
        height={height}
        width="80"
        color="#8b8680"
        radius="5"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default Loading;
